import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import store from '@/store';

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta: { showNavBar: false, showCanvasBG: true }
  },
  {
    path: '/drivers',
    name: 'drivers',
    component: () => import(/* webpackChunkName: "drivers" */ '../views/DriversView.vue'),
    meta: { showNavBar: true, showCanvasBG: false }
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '../views/AccountView.vue'),
    meta: { showNavBar: true, showCanvasBG: false }
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/UsersView.vue'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAdmin: true },
    props: true, // Позволяет передавать query-параметры как props
  },
  {
    path: '/admins',
    name: 'admins',
    component: () => import(/* webpackChunkName: "admins" */ '../views/AdminsView.vue'), // Предполагается, что AdminList.vue находится в папке views
    meta: { showNavBar: true, showCanvasBG: false, requiresAdmin: true },
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Navigation guard
router.beforeEach(async (to, from, next) => {
  // Check if user is logged in
  if (!store.state.users.user.isLogged) {
    await new Promise(resolve => setTimeout(resolve, 400)); // Give time to update store
  }
  const isLoggedIn = store.state.users.user.isLogged;
  const isAdmin = store.state.users.user.type === 1;

  // If route requires auth and user is not logged in
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({ name: 'login' });
  }
  // If route requires admin and user is not admin
  else if (to.matched.some(record => record.meta.requiresAdmin) && (!isLoggedIn || !isAdmin)) {
    next({ name: 'drivers' }); // Redirect to drivers if not admin
  } else {
    next();
  }
});

export default router;
